/**
 * Generated bundle index. Do not edit.
 */
export { extend, arrayUnion, PromiseCompleter, createComponent, DialogRef, DROP_IN_TYPE, OverlayRenderer, Modal, DOMOverlayRenderer, overlayConfigFactory, OverlayContext, OverlayContextBuilder, Overlay, ModalOverlay, OverlayDialogBoundary, OverlayTarget, DEFAULT_VALUES, ModalContext, ModalContextBuilder, ModalOpenContext, ModalOpenContextBuilder, ModalModule, privateKey, setAssignMethod, setAssignAlias, FluentAssignFactory, FluentAssign, DialogBailOutError, BaseDynamicComponent, CSSBackdrop, CSSDialogContainer } from './angular2-modal';
export { DOMOutsideEventPlugin as ɵa } from './providers/outside-event-plugin';
//# sourceMappingURL=angular2-modal.ng-flat.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/angular2-modal/src/angular2-modal.ng-flat.js
// module id = 25
// module chunks = 0